import { Tooltip as AntTooltip } from 'antd';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useRef } from 'react';

export const Tooltip = ({ parentContainer, className, ...props }) => {
  const ref = useRef();
  
  const getPopupContainer = useCallback(() => {
    return ref.current;
  }, []);
  
  return (
    <div ref={ref} className={className}>
      <AntTooltip {...props} getPopupContainer={parentContainer && getPopupContainer}/>
    </div>
  );
};

Tooltip.propTypes = {
  title: PropTypes.any,
  className: PropTypes.string,
  parentContainer: PropTypes.bool,
};

export default memo(Tooltip);
